<template>
  <div>
    <admd v-if="randValue == 0"></admd>
    <admd2 v-if="randValue == 1"></admd2>
  </div>
</template>

<script>


  export default {
    name: "abRouter",
    data(){
      return {
        randValue:-1
      }
    },
    components:{
      admd: ()=>import('@/views/admd'),
      admd2: ()=>import('@/views/abt')
    },
    methods:{
      getRandomIntInclusive(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
    },
    mounted(){
      /*if (localStorage.getItem('rNumber') == undefined) {
        this.randValue = this.getRandomIntInclusive(0,200) > 100 ? 1:0;
        localStorage.setItem('rNumber',this.randValue);
      } else {
        this.randValue = parseInt(localStorage.getItem('rNumber'),10);
      }*/
      this.randValue = 1
    }
  }
</script>

<style scoped>

</style>
